// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unverifiedBlocker__zKFAB {
  background: #f6f6f6;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 1000;
}

.card___omUr {
  margin: auto;
  margin-top: 110px;
}`, "",{"version":3,"sources":["webpack://./src/components/UnverifiedBlocker/unverifiedBlocker.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,eAAe;EACf,MAAM;EACN,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".unverifiedBlocker {\n  background: #f6f6f6;\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  z-index: 1000;\n}\n\n.card {\n  margin: auto;\n  margin-top: 110px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unverifiedBlocker": `unverifiedBlocker__zKFAB`,
	"card": `card___omUr`
};
module.exports = ___CSS_LOADER_EXPORT___;
